// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"144":"9845f82a","367":"9845f82a","512":"9845f82a"}[chunkId] + ".chunk.css";
};